import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import YearGroup from "./routes/YearGroup";
export default store => ({
  path: "gradebook",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-gradebook" */ "./components"),
        import(
          /* webpackChunkName: "admin-gradebook" */ "./modules/AdminGradebookModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "adminGradebook",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [YearGroup(store)],
});
